import { render, staticRenderFns } from "./DetailJoinClass.vue?vue&type=template&id=653391c6&"
import script from "./DetailJoinClass.vue?vue&type=script&lang=js&"
export * from "./DetailJoinClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports